import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import routerCount from './routerCount'
import scoreMain from '@/views/score/scoreMain.vue'
import goodsDetail from '@/views/score/goodsDetail.vue'
import scoreDetail from '@/views/score/scoreDetail.vue'
import orderDetail from '@/views/score/orderDetail.vue'
import scoreCharge from '@/views/score/scoreCharge.vue'
import scoreResult from '@/views/score/result.vue'
import award from '@/router/award'
import rules from '@/router/rules'
import shippingCommission from '@/views/shippingCommission/index.vue'
import cancelUpload from '@/views/cancelUpload/index.vue'
import { destroyH5 } from '@/utils/nativeAPI'
import privacy from '@/views/privacy/index.vue'
const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   redirect: '/scoreMain' // 添加重定向
  // },
  {
    path: '/scoreMain',
    name: 'ScoreMain',
    component: scoreMain,
    meta: {
      title: '我的积分',
      keepAlive: true, // init 缓存
      isDynamic: true, // 动态缓存
      isApp: true
    }
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: goodsDetail
  },
  {
    path: '/scoreDetail',
    name: 'ScoreDetail',
    component: scoreDetail,
    meta: {
      title: '积分明细',
      // keepAlive: true, // init 缓存
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: orderDetail,
    meta: {
      title: '订单详情',
      // keepAlive: true, // init 缓存
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/scoreCharge',
    name: 'ScoreCharge',
    component: scoreCharge,
    meta: {
      title: '积分充值',
      // keepAlive: true, // init 缓存
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/scoreResult',
    name: 'ScoreResult',
    component: scoreResult,
    meta: {
      title: '兑换结果'
    }
  },
  {
    path: '/shippingCommission',
    name: 'ShippingCommission',
    component: shippingCommission,
    meta: {
      title: '兑换结果'
    }
  },
  {
    path: '/cancelUpload',
    name: 'CancelUpload',
    component: cancelUpload,
    meta: {
      title: '平台间取消上传'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: privacy,
    meta: {
      title: '隐私协议'
    }
  },
  ...award,
  ...rules
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
routerCount(router, () => {
  destroyH5()
})
export default router
